import Button from 'components/control/button';
import styles from './style.module.scss';

const CtaButtons = () => {
  return (
    <div className={styles['cta-buttons']}>
      <a href="/contact-us" rel="noopener noreferrer">
        <Button theme="primary" label='Contact Us' />
      </a>
      <a href="/our-services" rel="noopener noreferrer">
        <Button theme="secondary" label='Learn More' />
      </a>
    </div>
  );
};

export default CtaButtons;